import React from "react";

const Index = () => {
  return (
    <div className="relative z-0">
      <section
        id="hero"
        className="relative bg-white py-10 md:py-52 px-6 lg:px-16 z-10 flex items-center justify-center"
      >
        <div className="container mx-auto px-4 flex flex-col lg:flex-row items-center justify-between relative z-20">
          <div className="w-full lg:w-1/2 text-left mb-8 lg:mb-0">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-4 text-primary leading-tight">
              Welcome to <span className="text-blue-400">CommerceMinder</span>
            </h1>
            <p className="text-sm md:text-base lg:text-lg mb-6 leading-relaxed text-primary">
              Driven by our mission to "Empowering E-Commerce and Beyond with Innovative Software and AI Solutions," Commerce Minder is a
              technology company dedicated to enhancing business value in the digital transformation era.
            </p>
            <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
              <button className="bg-gradient-to-r from-blue-500 to-blue-700 text-white font-semibold py-2 px-6 rounded-full shadow-lg hover:bg-blue-400 transition-all duration-300">
                Get Started
              </button>
              <a href="#about">
                <button className="bg-transparent border border-blue-500 text-blue-500 font-semibold py-2 px-6 rounded-full shadow-lg hover:bg-blue-500 hover:text-white transition-all duration-300">
                  Learn More
                </button>
              </a>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex items-center justify-center relative">
            <div className="relative w-full h-60 sm:h-80 lg:h-[400px] flex items-center justify-center">
              <div className="absolute w-full h-full bg-gradient-to-br from-blue-300 via-blue-400 to-blue-500 opacity-50 rounded-3xl blur-2xl"></div>

              <div className="relative z-10 backdrop-blur-md bg-white/30 border border-white/20 rounded-2xl shadow-2xl p-6 sm:p-8 text-center">
                <div className="flex flex-col items-center">
                  <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4">
                    Official IT Partner of <span className="text-secondary">ToptanTR</span>
                  </h2>
                  <p className="text-sm sm:text-base lg:text-lg text-primary mb-6">
                    Our flagship product, ToptanTR.
                  </p>
                  <a href="https://www.toptantr.com/tr/" target="_blank" rel="noopener noreferrer">
                    <button className="bg-gradient-to-r from-primary to-secondary text-white font-semibold py-2 px-6 rounded-full shadow-md hover:shadow-lg transition-transform transform hover:scale-105 duration-300" title="Visit ToptanTR">
                      Visit ToptanTR
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Index;
